/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-20 15:44:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-26 14:29:39
 */
import {EventBus} from './eventbus'
import store from '../store'
import {
  getToken
} from "./auth"
import {
  handleSessionStorage,
  handleTimeLocalStorage,
  handleScanCode,
} from "@/utils";
const signalR = require("@microsoft/signalr");
const withUrl="https://api.ticket.goldenyun.cn/wechath5/shoppingCartHub"
let connection=null
/* 服务器调用客户端方法 */
// 改变商品数量
const receiveChangeGoodsObj = {
  name: 'ReceiveChangeGoods',
  method: function(data) {
    console.log(data);
    EventBus.$emit("getMessage", data);
  }
};
// 获取初始购物车商品列表
const receiveGoodsListObj = {
  name: 'ReceiveGoodsList',
  method: function(data, isClear) {
    console.log('返回的购物车数据如下：');
    console.log(data);
    console.log('是否为清空购物车：' + isClear);
    EventBus.$emit("getGroupGoodsList", data, isClear);
  }
};
const receiveErrorMsg = {
  name: 'ReceiveErrorMsg',
  method: function(data) {
    console.log('服务端日志如下：');
    console.log(data);
    
    // EventBus.$emit("getGroupGoodsList", data, isClear);
  }
};

// 服务器端的方法
// const serverMethodSets = [updateOrderPrint];
// 客户端的方法
const clientMethodSets = [receiveChangeGoodsObj, receiveGoodsListObj,receiveErrorMsg]; // 将需要注册的方法放进集合
function initConnect() {
  if(connection)return;
      connection = new signalR.HubConnectionBuilder()
        // .withUrl(withUrl, {  accessTokenFactory: () => getToken(),skipNegotiation: true,
        .withUrl(withUrl, {  skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets})
        // .configureLogging(signalR.LogLevel.Error)
        .withAutomaticReconnect()  // 断开自动重连
        .build();
      createReceiveFunction()
      // connection.on("ReceiveMessage", data => {
        
        
      //   EventBus.$emit("getMessage", data);
        
      // });
 
      // 生命周期
      // this.connection.onreconnecting(error => {
      //   console.log('重新连接ing',error);
      // });
      // this.connection.onreconnected(connectionId => {
      //   console.log('链接id',connectionId);
      // });
      // this.connection.onclose(error => {
      //   console.log('关闭',error);
      // });
      // 开始链接
      // this.connection.start();
       connection
      .start()
      .then((res) => {
        console.log('链接成功')
        console.log(res)
        store.commit('set_point_connet','111')
        let cusId = localStorage.getItem("consumerId");
        let personNum= store.state.order.orderPeople
        console.log('用户id:'+cusId)
        console.log(store)
        handleSendMessage("SendMessage",{UserId:cusId-0,PersonNum:personNum} )
        const vpnStorage = handleSessionStorage.get("vpnInfo");
        const teamId=handleSessionStorage.get("teamId")

        handleSendMessage("SendGoodsList", {
          TeamId: teamId,
          duration:vpnStorage.OrderTeamDuration,
        });
      })
      .catch((err) => {
        console.log(err);
      })
}

function createReceiveFunction() {
  if (!connection) return;
  // 注册客户端方法
  clientMethodSets.map((item) => {
    connection.on(item.name, item.method);
  });
}
// 发送消息给服务器
// function handleSendMessage(params){
//   if(!connection)return;
//   connection
//     .invoke("SendMessage", params)  // invoke(方法名, 参数)
//     .then(() => console.log("send succeed!"));
// }
function handleSendMessage(method, params) {
  if (!connection) return;
  console.log('发送的数据我如下----------')
  console.log(params)
  connection
    .invoke(method, params) // invoke(方法名, 参数)
    .then(() => console.log(method+"发送成功!"))
    .catch((err) => {
        console.log(err);
      });
}
export {initConnect,handleSendMessage}
    